//import _merge from 'lodash/merge'

// receives normalized entities and merges them into state
export default (
    state = {},
    action
) => {
    if (action.normalized) {
        //return _merge(state, action.normalized.entities);
        return action.normalized.entities;
    }

    if (action.payload && action.payload.normalized) {
        //return _merge(state, action.payload.normalized.entities);
        return  action.payload.normalized.entities;
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/entities.js